import React, { Component } from "react";

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

class PricingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first: "",
      last: "",
      email: "",
      phone: "",
      message: "",
      package: this.props.package,
      submitted: false,
      error: false
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.isValidEmail = this.isValidEmail.bind(this);
    this.isValidPhone = this.isValidPhone.bind(this);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  isValidEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  isValidPhone(phone) {
    const number = phone.replace(/\W/g, "");
    return number.length === 10 && !isNaN(number);
  }

  onSubmit(e) {
    e.preventDefault();
    if (
      this.state.first !== "" &&
      this.state.last !== "" &&
      this.state.email !== "" &&
      this.state.phone !== "" &&
      this.state.message !== "" &&
      this.isValidEmail(this.state.email) &&
      this.isValidPhone(this.state.phone)
    ) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "pricing", ...this.state })
      })
        .then(() => {
          document.getElementById("pricing").reset();
          this.setState({
            submitted: true,
            error: false
          });
        })
        .catch(error => {
          this.setState({
            error: true
          });
        });
    } else {
      this.setState({
        error: true
      });
    }
  }

  render() {
    let message;
    if (this.state.error) {
      message = (
        <p
          className={`has-text-danger ${
            this.state.error ? "" : "is-invisible"
          }`}
        >
          Please make sure you have filled out all of the fields correctly.
        </p>
      );
    } else if (this.state.submitted) {
      message = (
        <p
          className={`has-text-primary ${
            this.state.submitted ? "" : "is-invisible"
          }`}
        >
          Thank you for your inquiry. I'll get back to you as soon as possible!
        </p>
      );
    } else {
      message = <p />;
    }
    return (
      <div>
        <iframe name="hide" title="hidden" className="is-hidden" />
        <form
          name="pricing"
          action="#"
          method="POST"
          id="pricing"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <input type="hidden" name="bot-field" />
          <input type="hidden" name="form-name" value="pricing" />

          <div className="columns is-multiline">
            <div className="column is-12 has-text-centered">{message}</div>
            <div className="column is-6">
              <div className="field">
                <input
                  className="input"
                  type="text"
                  name="first"
                  placeholder="First Name"
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="column is-6">
              <div className="field">
                <input
                  className="input"
                  type="text"
                  name="last"
                  placeholder="Last Name"
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="column is-6">
              <div className="field">
                <input
                  className="input"
                  type="text"
                  name="email"
                  placeholder="Email"
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="column is-6">
              <div className="field">
                <input
                  className="input"
                  type="tel"
                  name="phone"
                  placeholder="Telephone"
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="column is-12">
              <div className="field">
                <textarea
                  className="textarea has-fixed-size"
                  placeholder="Provide more information here..."
                  name="message"
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="column is-12">
              <div className="field is-hidden-field">
                <input
                  type="text"
                  className="input"
                  name="package"
                  value={this.props.package}
                />
              </div>
            </div>
            <div className="column is-12 has-text-centered">
              <div className="field">
                <input
                  className="button is-primary"
                  type="submit"
                  name="submit"
                  value={this.props.buttonText}
                  onClick={e => this.onSubmit(e)}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default PricingForm;
